export default __webpack_public_path__ + "static/media/question-mark-in-circle.41b2cf80.svg";